// extracted by mini-css-extract-plugin
export var contactFormTitle = "rust-development-module--contact-form-title--f3k63";
export var contactTitle = "rust-development-module--contact-title--aF3rl";
export var downloadImage = "rust-development-module--download-image--5vLu+";
export var header = "rust-development-module--header--jdhef";
export var innerWrapper = "rust-development-module--inner-wrapper--gJvHJ";
export var outerWrapper = "rust-development-module--outer-wrapper--U6TWc";
export var section = "rust-development-module--section--2Pw1-";
export var stylesContactSection = "rust-development-module--styles-contact-section--8Zp5R";